<!--队员管理-->
<template>
  <div class="team-member-page">
    <!-- 导航栏 -->
    <van-nav-bar
      class="custom-nav-bar"
      title="队员管理"
      left-text="返回"
      left-arrow
      @click-left="onTopClickLeft"
    >
      <a
        :href="
          routeValue === null ||
          routeValue === undefined ||
          routeValue.length === 0
            ? 'https://www.ptty.com.cn/wap/#/'
            : 'https://www.ptty.com.cn/wap/#/' + routeValue
        "
        slot="right"
        class="home-link"
      >
        <van-icon name="wap-home" class="home-icon" />
      </a>
    </van-nav-bar>

    <!-- 赛事标题 -->
    <div class="event-title-card">
      <van-icon name="trophy-o" class="title-icon" />
      <span class="title-text">{{ SSMC }}</span>
    </div>

    <!-- 队伍信息卡片 -->
    <div class="team-info-section">
      <div class="section-header">
        <van-icon name="friends-o" class="section-icon" />
        <span class="section-title">队伍信息</span>
      </div>
      <div class="info-card">
        <van-cell title="队伍全称" :value="DWXX.DWQC" />
        <van-cell title="队伍简称" :value="DWXX.DWJC" />
        <van-cell title="领队名称" :value="DWXX.LDXM" />
        <van-cell title="领队电话" :value="DWXX.LDTEL" />
      </div>
    </div>

    <!-- 报名要求和规程说明 -->
    <div class="content-section">
      <div class="info-block" v-if="BMNR.length > 0">
        <div class="block-header">
          <van-icon name="info-o" class="block-icon" />
          <span class="block-title">报名要求</span>
        </div>
        <div class="block-content" v-html="BMNR"></div>
      </div>

      <div class="info-block">
        <div class="block-header">
          <van-icon name="description-o" class="block-icon" />
          <span class="block-title">规程说明</span>
        </div>
        <div class="block-content" v-html="SSGC"></div>
      </div>
    </div>

    <div class="bottom-spacer"></div>

    <!--底部按钮  开始-->
    <van-tabbar v-if="SSISBM === 'Y'" class="custom-tabbar">
      <van-goods-action class="custom-goods-action">
        <van-goods-action-button
          type="primary"
          @click="copyUrl"
          text="邀请队员"
          dot
          class="action-btn"
        />
        <van-goods-action-button
          v-if="IS_S === '1' || IS_D === '1'"
          type="info"
          text="单项报名"
          @click="jumpDxBmUrl('DX', 'DY')"
          class="action-btn"
        />
        <van-goods-action-button
          type="danger"
          v-if="isLd === '1' && IS_T === '1'"
          text="团体赛报名"
          @click="teamTccVisible = true"
          class="action-btn"
        />
        <van-goods-action-button
          type="danger"
          v-if="isLd !== '1' && IS_T === '1'"
          text="团体成员报名"
          @click="jumpTeamCyBmUrl('T', 'DY')"
          class="action-btn"
        />
        <van-goods-action-button
          type="info"
          v-if="isLd === '1'"
          text="管理队员"
          @click="jumpDyGlHandler()"
          class="action-btn"
        />
      </van-goods-action>
    </van-tabbar>
    <!--底部按钮  结束-->

    <!-- 选择组别弹出框  开始 -->
    <van-action-sheet v-model="zbShowVisible" title="请选择组别">
      <!-- <van-tabs
        v-model="active"
        v-if="checkBmrsLx.substr(0, 1) === 'T'"
        @change="tabTeamChangeHander"
      >
        <van-tab title="团体项目报名" v-if="checkBmrsLx === 'TLD'"></van-tab>
        <van-tab title="团体成员报名"></van-tab>
      </van-tabs> -->
      <van-row>
        <van-col span="12">
          <div
            v-if="checkBmrsLx.substr(0, 1) === 'T' && isTopItemShow"
            style="color:#fff;display: flex;align-items: center;justify-content: center;background: green; height: 41px;margin-top: 5px;margin-left: 15px;margin-right: 10px;font-size: 14px;border-radius: 8px;"
          >
            <div
              v-bind:style="{
                width: '63%',
                textAlign: 'center',
                borderBottom: active === 0 ? '3px solid #fff' : 'none',
                marginLeft: '15px',
                marginRight: '15px',
                height: '24px',
                lineHeight: '24px'
              }"
            >
              <div @click="tabTeamChangeHander(0)" v-bind:style="{}">
                团体项目报名
              </div>
            </div>
          </div>
        </van-col>
        <van-col span="12">
          <div
            v-if="checkBmrsLx.substr(0, 1) === 'T' && isTopItemShow"
            style="color:#fff;display: flex;align-items: center;justify-content: center;background: #870404; height: 41px;margin-top: 5px;margin-left: 8px;margin-right: 15px;font-size: 14px;border-radius: 8px;"
          >
            <div
              v-bind:style="{
                width: '63%',
                textAlign: 'center',
                borderBottom: active === 1 ? '3px solid #fff' : 'none',
                marginLeft: '15px',
                marginRight: '15px',
                height: '24px',
                lineHeight: '24px'
              }"
            >
              <div @click="tabTeamChangeHander(1)">
                添加团体成员
              </div>
            </div>
          </div>
        </van-col>
      </van-row>

      <div style="background: #F2F2F2;">
        <change-xm
          :ISBMRCOUNT="ISBMRCOUNT"
          :ssid="ssid"
          :resultXmList="resultXmList"
          :sslxList="sslxList"
          :utilPost="utilPost"
          :reportLx="reportLx"
          :isLd="isLd"
          :czlx="czlx"
          bmLx="TEAM"
          :dwid="DWID"
          :checkBmrsLx="checkBmrsLx"
        ></change-xm>
        <div style="height:100px;width:15px;"></div>
      </div>
    </van-action-sheet>
    <!-- 选择组别弹出框  结束 -->

    <!-- 团体赛弹出框类型 开始 -->
    <van-action-sheet v-model="teamTccVisible" title="请选择操作类型">
      <div class="team-action-content">
        <div class="action-button team-project-btn">
          <div class="btn-icon">
            <van-icon name="friends-o" />
          </div>
          <div class="btn-content">
            <div class="btn-title" @click="jumpTeamLdBmUrl('T', 'LD')">
              团体项目报名
            </div>
          </div>
          <van-icon name="arrow" class="btn-arrow" />
        </div>

        <div class="action-button team-member-btn">
          <div class="btn-icon">
            <van-icon name="manager-o" />
          </div>
          <div class="btn-content">
            <div class="btn-title" @click="jumpTeamCyBmUrl('T', 'DY')">
              添加团体成员
            </div>
          </div>
          <van-icon name="arrow" class="btn-arrow" />
        </div>
      </div>
    </van-action-sheet>
    <!-- 团体赛弹出框 结束 -->
    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import ChangeXm from "../commonCom/ChangeXm.vue";
export default {
  name: "TeamRyItemBm",
  components: { ChangeXm, LoadingCom },
  data() {
    return {
      teamTccVisible: false,
      isTopItemShow: false,
      active: 0,
      checkBmrsLx: "",
      BMNR: "",
      SSGC: "",
      BSLXR: "",
      BSLXRTEL: "",
      selectRyidCheckBoxDatas: [],
      dwGlShowVisible: false,
      zbShowVisible: false,
      activeNames: ["1"],
      utilPost: "",
      ssid: "",
      DWID: "",
      SSMC: "",
      ZRS: "",
      ZBCOUNT: "",
      DWXX: {},
      MRYLIST: [],
      WRYLIST: [],
      resultXmList: [],
      sslxList: [],
      czlx: "",
      pageSet: {
        currentPage: 1, //当前页页码
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      search: {
        info: "",
        qslx: "",
        bszt: "",
        ssid: ""
      },
      ssInfo: {},
      isLd: "0", //是否为领队
      IS_S: "0",
      IS_D: "0",
      IS_T: "0",
      SSISBM: "N",
      ISBMRCOUNT: 0,
      reportLx: "", // LDBM：领队报名 主要用于区分团体  GRDWBM：纯个人队伍报名  DYBM：队员报名，有队伍的情况下 CJMDBM：通过采集名单的方式报名
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.DWID = this.$route.query.DWID;
    this.czlx = this.$route.query.czlx;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.getDwInfo();
    this.getBmnrAndSsgc();
    this.getIsBmLoad();
  },
  methods: {
    tabTeamChangeHander(type) {
      this.active = type;
      if (this.active === 0) {
        this.openBmHandler("T", "LD", true);
      } else if (this.active === 1) {
        this.openBmHandler("T", "DY", false);
      }
    },
    getIsBmLoad() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "checkIsBm" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.SSISBM = data.content;
        if (this.SSISBM !== "Y") {
          this.$notify({
            type: "danger",
            message: "报名未开始或已结束",
            duration: 6000
          });
          return;
        }
      });
    },
    getDwInfo() {
      var busData = {
        DWID: this.DWID
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "dyGl" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.SSMC = data.content.SSMC;
        this.DWXX = data.content.DWXX;
        var arrayLdxm = this.DWXX.LDXM.split("&");
        var arrayLdtel = this.DWXX.LDTEL.split("&");
        this.DWXX.LDXM = arrayLdxm[0];
        this.DWXX.LDTEL = arrayLdtel[0];
        this.BSLXR = arrayLdxm[1];
        this.BSLXRTEL = arrayLdtel[1];
        this.ZBCOUNT = data.content.ZBCOUNT;
        this.ZRS = data.content.ZRS;
        this.isLd = data.content.ISLD;
        this.IS_S = data.content.IS_S;
        this.IS_D = data.content.IS_D;
        this.IS_T = data.content.IS_T;
      });
    },
    getBmnrAndSsgc() {
      this.search.ssid = this.ssid;
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSsxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.ssInfo = data.content[0];
        this.BMNR = data.content[0].BMNR;
        this.SSGC = data.content[0].SSGC;
      });
    },
    getXmData(sslxTypeRequest, isZbShowVisible) {
      //获取比赛项目
      var busData = {
        czlx: this.czlx,
        dwid: this.DWID,
        bmLx: "TEAM",
        sslxTypeRequest: sslxTypeRequest,
        isLd: this.isLd,
        reportLx: this.reportLx,
        isLoadDtInfo: "0",
        isLoadRyCount: "0"
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getXmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }

        this.resultXmList = data.content.resultXmList;
        if (this.reportLx === "DYBM" && sslxTypeRequest === "T") {
          if (this.resultXmList.length === 0) {
            this.$notify({
              type: "danger",
              message:
                "未检测到团体项目，请先联系领队，报名对应的团体项目后，队员才能进行报名",
              duration: 6000
            });
            return;
          }
        }
        this.sslxList = data.content.sslxList;
        this.ISBMRCOUNT = data.content.ISBMRCOUNT;
        this.zbShowVisible = true;
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },

    //选择组别弹出框
    openZbShowHandler() {
      this.zbShowVisible = true;
    },
    //跳转
    navToAddRyUrl(navType) {
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: "",
          bmLx: "TEAM",
          dwid: this.DWID,
          czlx: "ADD"
        }
      });
    },

    copyUrl() {
      // http://localhost:8668/#/teamRyItemBm?DWID=DW241020YG045416&czlx=ADD
      const oInput = document.createElement("input");
      // 这边为链接地址this.liveLink='www.baidu.com'
      oInput.value =
        "https://www.ptty.com.cn/wap/#/teamRyItemBm?ssid=" +
        this.ssid +
        "&DWID=" +
        this.DWID +
        "&czlx=ADD";
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand("Copy");
      oInput.remove();
      alert("复制成功");
    },
    editorCyHandler(row) {
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: "",
          bmLx: "TEAM",
          dwid: this.DWID,
          czlx: "UPT",
          ryid1Param: row.RYID,
          ryid2Param: ""
        }
      });
    },
    teamOpenBmHandler(type, rylx, isZbShowVisible) {
      this.isTopItemShow = false;
      if (rylx === "LD") {
        this.isTopItemShow = true;
      }
      this.openBmHandler(type, rylx, isZbShowVisible);
    },
    openBmHandler(type, rylx, isZbShowVisible) {
      this.checkBmrsLx = type + rylx;
      if (rylx === "LD") {
        this.active = 0;
        this.reportLx = "LDBM";
      }
      if (rylx === "DY") {
        this.active = 1;
        this.reportLx = "DYBM";
      }

      this.getXmData(type, isZbShowVisible);
    },
    jumpDyGlHandler() {
      this.$router.push({
        path: "/dyGl",
        query: {
          ssid: this.ssid,
          DWID: this.DWID,
          czlx: "ADD"
        }
      });
    },
    copyTrial() {
      if (!confirm("是否拷贝比赛？")) {
        return;
      }
    },
    //单项报名Url
    jumpDxBmUrl(type, rylx) {
      this.checkBmrsLx = type + rylx;
      if (rylx === "LD") {
        this.active = 0;
        this.reportLx = "LDBM";
      }
      if (rylx === "DY") {
        this.active = 1;
        this.reportLx = "DYBM";
      }
      this.$router.push({
        path: "/projectListIndex",
        query: {
          ssid: this.ssid,
          showXmlx: "DX",
          reportLx: this.reportLx,
          isLd: "0",
          bmLx: "TEAM",
          dwid: this.DWID,
          czlx: this.czlx,
          checkBmrsLx: this.checkBmrsLx
        }
      });
    },
    //领队报名团体项目
    jumpTeamLdBmUrl(type, rylx) {
      this.checkBmrsLx = type + rylx;
      this.reportLx = "LDBM";
      this.$router.push({
        path: "/projectListIndex",
        query: {
          ssid: this.ssid,
          showXmlx: "TEAM",
          reportLx: this.reportLx,
          isLd: "1",
          bmLx: "TEAM",
          dwid: this.DWID,
          czlx: this.czlx,
          checkBmrsLx: this.checkBmrsLx
        }
      });
    },
    //添加团体成员
    jumpTeamCyBmUrl(type, rylx) {
      this.checkBmrsLx = type + rylx;
      this.reportLx = "DYBM";
      this.$router.push({
        path: "/projectListIndex",
        query: {
          ssid: this.ssid,
          showXmlx: "TEAM",
          reportLx: this.reportLx,
          isLd: "0",
          bmLx: "TEAM",
          dwid: this.DWID,
          czlx: this.czlx,
          checkBmrsLx: this.checkBmrsLx
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/* 字体渲染优化 */
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 页面容器 */
.team-member-page {
  min-height: 100vh;
  background: #f5f6fa;
}

/* 导航栏 */
.custom-nav-bar {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);

  /deep/ .van-nav-bar__title {
    color: #fff;
    font-weight: 700;
    font-size: 1.125rem;
  }

  /deep/ .van-nav-bar__text,
  /deep/ .van-icon {
    color: #fff;
  }
}

.home-link {
  display: flex;
  align-items: center;
  color: #fff;
}

.home-icon {
  font-size: 1.375rem;
}

/* 赛事标题卡片 */
.event-title-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  background: #fff;
  border-bottom: 3px solid #185f9b;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.title-icon {
  font-size: 1.5rem;
  color: #185f9b;
}

.title-text {
  font-size: 1.0625rem;
  font-weight: 700;
  color: #333;
}

/* 队伍信息区域 */
.team-info-section {
  margin: 1rem;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border-radius: 0.75rem 0.75rem 0 0;
}

.section-icon {
  font-size: 1.25rem;
  color: #fff;
}

.section-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

.info-card {
  background: #fff;
  border-radius: 0 0 0.75rem 0.75rem;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  /deep/ .van-cell {
    padding: 0.875rem 1rem;
  }

  /deep/ .van-cell__title {
    color: #6b7280;
    font-weight: 500;
  }

  /deep/ .van-cell__value {
    color: #1f2937;
    font-weight: 600;
  }
}

/* 内容区域 */
.content-section {
  margin: 0 1rem 1rem;
}

.info-block {
  background: #fff;
  border-radius: 0.75rem;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.block-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 2px solid #e9ecef;
}

.block-icon {
  font-size: 1.125rem;
  color: #185f9b;
}

.block-title {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #333;
}

.block-content {
  padding: 1rem;
  color: #4b5563;
  font-size: 0.875rem;
  line-height: 1.6;

  /deep/ p {
    margin: 0.5rem 0;
  }

  /deep/ ul,
  /deep/ ol {
    padding-left: 1.5rem;
    margin: 0.5rem 0;
  }
}

/* 底部间距 */
.bottom-spacer {
  height: 5rem;
}

/* 底部操作栏 */
.custom-tabbar {
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
}

.custom-goods-action {
  /deep/ .van-goods-action-button {
    font-weight: 600;
    font-size: 0.9375rem;
  }

  /deep/ .van-goods-action-button--primary {
    background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  }
}

/* 团体赛弹出框样式 */
.team-action-content {
  padding: 1rem;
}

.action-button {
  display: flex;
  align-items: center;
  padding: 1.25rem 1rem;
  margin-bottom: 0.75rem;
  background: #fff;
  border-radius: 0.875rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  border: 2px solid transparent;

  &:last-child {
    margin-bottom: 0;
  }

  &:active {
    transform: scale(0.98);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

.team-project-btn {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-color: rgba(24, 95, 155, 0.2);

  &:hover {
    border-color: rgba(24, 95, 155, 0.4);
    box-shadow: 0 4px 20px rgba(24, 95, 155, 0.15);
  }

  .btn-icon {
    background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  }
}

.team-member-btn {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-color: rgba(52, 211, 153, 0.2);

  &:hover {
    border-color: rgba(52, 211, 153, 0.4);
    box-shadow: 0 4px 20px rgba(52, 211, 153, 0.15);
  }

  .btn-icon {
    background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
  }
}

.btn-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  .van-icon {
    font-size: 1.5rem;
    color: #fff;
  }
}

.btn-content {
  flex: 1;
  min-width: 0;
}

.btn-title {
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}

.btn-desc {
  font-size: 0.8125rem;
  color: #666;
  line-height: 1.4;
}

.btn-arrow {
  font-size: 1.125rem;
  color: #999;
  margin-left: 0.5rem;
  flex-shrink: 0;
}

.van-button--warning,
.van-button--primary {
  width: 130px;
  height: 35px;
}
/deep/ .van-checkbox__icon--round {
  position: absolute;
  top: 0px;
  left: -15px;
}
/deep/ .van-button--primary {
  height: 40px !important;
}
/deep/ .van-button--warning {
  height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/TeamRyItemBm.vue